export default "__VITE_ASSET__DkhXLcJP__"